import { Fragment, useEffect, useState } from "react";
import { Form, Button, FormLabel, FormGroup, FormControl, Row, Col, Table } from "react-bootstrap";
import { Formik, FieldArray } from "formik";
import DatePicker from "react-datepicker";
import * as yup from "yup";
import { useSelector} from "react-redux";
import useFullPageLoader from "app/hooks/useFullPageLoader ";
import Select from 'react-select'
import { useLazyGetCRMCustomerDetailsListQuery } from "app/redux/Customer/customerApi";
import {ArrowLeftCircle, PersonAdd} from "react-bootstrap-icons";
import AddCustomerModal from "app/views/dashboard/modal/AddCustomerModal";
import { format } from "date-fns";
import {useLazyUpdateContactPersonsQuery} from "app/redux/ownership/ownershipApi";
import { toast } from "react-toastify";

export default function AddEditOwnerships({
    show,
    handleFormContractPersonSubmit,
    toggleContractPersonEditorDialog,
    persondetails,
    initialValues = {}
  }) {

    const [UpdateContactPersons] = useLazyUpdateContactPersonsQuery();

    const [addCustomerModalState, setAddCustomerModalState] = useState({
        addCustomerdialogValues: null,
        addCustomershowEditorDialog: false
    });

    const [isFormSubmit, setFormSubmit] = useState(false);
    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const [customerFullDetailList, setCustomerFullDetailListState] = useState([]);
    let [customerDetailList, setCustomerDetailListState] = useState([]);
    let [renterStartDateState, setRenterStartDateState] = useState('');
    let [renterEndDateState, setRenterEndDateState] = useState('');

    let [ContractId, setContractIdState] = useState('');
    let [screenType, setScreenTypeState] = useState('');
    let [OwnershipDate, setOwnershipDateState] = useState('');
    let [OwnerShipEndDate, setOwnerShipEndDateState] = useState('');
    let [ContractRenterType, setContractRenterTypeState] = useState(2);

    const [state, setState] = useState({
     personList: []
    });
    const { selectedCompanyId } = useSelector((state) => state.company);
    const [getCRMCustomerDetailsList] = useLazyGetCRMCustomerDetailsListQuery();

    const addCustomerToggleEditorDialog = (arg) => {
        if (arg && arg.toString()) {
            setAddCustomerModalState((prevState) => ({ ...prevState, addCustomershowEditorDialog: true, addCustomerdialogValues: null }));
        } else {
            setAddCustomerModalState((prevState) => ({
            ...prevState,
            addCustomerdialogValues: null,
            addCustomershowEditorDialog: !addCustomerModalState.addCustomershowEditorDialog
            }));
        }
    };

    useEffect(() => {
      setPreValues(initialValues);
      fetchCRMCustomerDetailsList(0, initialValues.screenType);
    }, []);

    const setPreValues = (preValues) => {
      if(preValues){
        setContractIdState(preValues.ContractId);
        setScreenTypeState(preValues.screenType);
        setOwnershipDateState(preValues.OwnershipDate);
        setOwnerShipEndDateState(preValues.OwnerShipEndDate);
        setRenterStartDateState(preValues.OriginalRenterStartDate);
        setRenterEndDateState(preValues.OriginalRenterEndDate);
        setContractRenterTypeState(preValues.contractRenterType);
      }
    }

    const setExistingOwnerData = (customerData) => {
   
      
      if(persondetails && persondetails.length > 0){
        persondetails.forEach((item, indx) => {
          if(item.ContractRenterID){
            setCustomerInOwnership(item.ContractRenterID, customerData, "Edit", item.InvoiceRecipient, item.ContractRenterRowID);
          }
        });
      }

      if(persondetails && persondetails.ContractRenterID){
        setCustomerInOwnership(persondetails.ContractRenterID, customerData, "Edit");
      }
     
    }

    const fetchCRMCustomerDetailsList = async(custId, type="") => {
        showLoader();
        getCRMCustomerDetailsList({
            CompanyId: selectedCompanyId,
            CustomerType: 3,
            IsArchive: false,
            ContractTypeID: 0
          }).then((result) => {
            hideLoader();
            if (result.isSuccess) {
              let tempdata = result.data.data;
              let customerData = tempdata.map((e) => ({
                ...e,
                value: e.CustomerId,
                label: e.ContactName
              }));
              //console.log('customerdata -- ', customerData);
              if(custId && custId !== 0){
                setCustomerInOwnership(custId, customerData, "New");
              }
              setCustomerFullDetailListState(customerData);
              setCustomerDetailListState(customerData);
              if(type === "Edit"){
                setExistingOwnerData(customerData);
              }
            }
          });
    }

    const setCustomerInOwnership = (custId, customerData, type, IsInvoiceRecipient=false, ContractRenterRowID = 0) => {
        if(custId && custId !== 0){
            let selectedCustDetail = customerData.filter(a => a.CustomerId === custId);
            if(selectedCustDetail && selectedCustDetail.length > 0){
                let ownerdet = state.personList;
                if(ownerdet && ownerdet.length > 0){
                  const chkAlreadyExists = ownerdet.filter(a => a.CustomerID === custId);
                  if(chkAlreadyExists && chkAlreadyExists.length > 0){
                    return;
                  }
                }
                let tempval = {};
                tempval.CustomerID = selectedCustDetail[0].CustomerId
                tempval.Name =selectedCustDetail[0].CustomerNickName;
                tempval.Email = selectedCustDetail[0].PrimaryEmail;
                tempval.Phone = selectedCustDetail[0].PrimaryPhone;
                tempval.IsPrivateCustomer = true;
                tempval.InvoiceRecipient = IsInvoiceRecipient;
                tempval.ContractRenterRowID = ContractRenterRowID;
                ownerdet.push(tempval);
                setState({
                    personList: ownerdet
                });
                
            }
            
         }
    }

    const handleSubmit = async () => {
        showLoader();  
        let isFormValid = true;
        let formInvalidMesaage = "";
        setFormSubmit(true);
        let persondetailsList = state.personList;
        
        if(renterStartDateState === ""){
            isFormValid = false;
            formInvalidMesaage = "start date cannot be blank";
        }
       
        if(isFormValid){
          
            const ContractTypeId = 0;
            const OwnerShipDate = format(OwnershipDate, "yyyy-MM-dd");
            let OwnerShipEndDate = "";
            if(OwnerShipEndDate !== "" ){
                    OwnerShipEndDate = format(OwnerShipEndDate, "yyyy-MM-dd");
            }

            const Price = 0;
            const Notes = "";
            const AddedByPersonID = localStorage.getItem('loginUserPersonId');
            const AddedByUserRoleID = 1;
            const AddedByCompanyId = localStorage.getItem('CompanyId');
            const NoOfRenters = persondetailsList;

            const RenterTypeId = 2;
            const contractRenterType = 2;
            const source = "KeyFree";

            let newFormData = {};
            newFormData.ContractTypeId = 0;
            newFormData.ContractId = ContractId;
            newFormData.OwnerShipDate = OwnerShipDate;
            newFormData.OwnerShipEndDate = OwnerShipEndDate;
            newFormData.RenterStartDate = OwnerShipDate;
            newFormData.RenterEndDate = null;
            newFormData.MoveInDate = null;
            newFormData.Price = Price;
            newFormData.Notes = Notes;
            newFormData.AddedByPersonID = AddedByPersonID;
            newFormData.AddedByUserRoleID = AddedByUserRoleID;
            newFormData.AddedByCompanyId = AddedByCompanyId;
            newFormData.RenterTypeId = RenterTypeId;
            newFormData.contractRenterType = contractRenterType;
            newFormData.source = source;
            
            let NoOfReterArray = [];
            
            NoOfRenters.forEach((item, indx) => {
              let owner = {};
              owner.ContractRenterID = item.CustomerID;
              owner.ContractRenterName = item.Name;
              owner.ContractRenterRowID = item.ContractRenterRowID ?? 0;
              owner.InvoiceRecipient = item.IsInvoiced;
              NoOfReterArray.push(owner);
            });

            let rowidsToBeEdited = [];
            persondetails.forEach((item, indx) => {
                if(item.ContractRenterRowID && item.ContractRenterRowID !== 0){
                  rowidsToBeEdited.push(item.ContractRenterRowID);
                }
            });
            newFormData.NoOfRenters = NoOfReterArray;
            newFormData.EditedRowIds = rowidsToBeEdited;
            await UpdateContactPersons(newFormData).then((result) => {
                hideLoader();
                if(result.data.isSuccess){
                    toast.success("Renter updated successfully", { autoClose: 2000 });
                    handleFormContractPersonSubmit();
                    toggleContractPersonEditorDialog(false);
                }
                else{
                    toast.error(result.data.message, { autoClose: 2000 });
                }
                }, error => {
                hideLoader();
                toast.error(error);
            });
          
          
        }
        else{
          hideLoader();
          if(!isFormValid){
            toast.error(formInvalidMesaage, { autoClose: 2000 });
          }
        }


    };

    const handleDeleteCustomer = async (itemIndx, customerId) => {
      let ownerdet = state.personList;
      ownerdet = ownerdet.filter(a => a.CustomerID !== customerId);
      setState({
        personList: ownerdet
      });
    };

    const onChange = (event) => {
        if(event){
           customerDetailList = customerDetailList.filter(a => a.CustomerId !== event.CustomerId);
           setCustomerDetailListState(customerDetailList);
           let ownerdet = state.personList;
           let ownerdetLength = 0;
           if(ownerdet && ownerdet.length > 0){
             ownerdetLength = ownerdet.length;
           }
           let tempval = {};
           tempval.CustomerID = event.CustomerId
           tempval.Name =event.CustomerNickName;
           tempval.Email = event.PrimaryEmail;
           tempval.Phone = event.PrimaryPhone;
           tempval.IsInvoiced = ownerdetLength === 0 ? true : false;
           ownerdet.push(tempval);
           setState({
             personList: ownerdet
           });
        }
       };

    const addCustomerHandleFormSubmit = async (values) => {
        fetchCRMCustomerDetailsList(values);
        addCustomerToggleEditorDialog(false);
    };
    

  let { addCustomerdialogValues, addCustomershowEditorDialog } = addCustomerModalState;
  return (
    <div className="invoice-viewer py-3">
        <Fragment>
              <Form className="px-3">
                <div className="viewer_actions d-flex align-items-center justify-content-end gap-2 mb-4">
                  <Button
                    type="button"
                    variant="primary"
                    onClick={() => toggleContractPersonEditorDialog(false)}>
                   <ArrowLeftCircle className={'me-2'} size={17}></ArrowLeftCircle>
                    Tilbake
                  </Button>
                  <Button variant="primary" onClick={() => handleSubmit()}>
                    Lagre
                  </Button>
                </div>

                <Row className="justify-content-between">
                  <Col md={6} sm={7}>
                    <h4 className="fw-bold">
                        {screenType === "Edit" ? "Redigere" : "Legge til"} kontaktperson
                    </h4>
                  </Col>
                </Row>
                

                <div className="mt-3 mb-4 border-top" />

                <Row>
                <Col xs={12}>
                        <Table responsive hover className="mb-3">
                          <thead className="bg-gray-300">
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Navn</th>
                              <th scope="col">E-post</th>
                              <th scope="col">Telefon</th>
                              <th scope="col"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {state.personList.map((item, ind) => (
                              <tr key={ind}>
                                <th className="text-middle" scope="row">
                                  {ind + 1}
                                </th>
                                <td>
                                    {item.Name}
                                </td>
                                <td>
                                    {item.Email}
                                </td>
                                <td>
                                    {item.Phone}
                                </td>
                                <td>
                                  <button
                                    type="button"
                                    onClick={() => handleDeleteCustomer(ind, item.CustomerID)}
                                    className="btn btn-outline-secondary float-right">
                                    Slett
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>

                        {/* {isFormSubmit && state.personList.length === 0 &&
                          <small className="text-danger">Minimum 1 vare kreves</small>
                        } */}

                        

                        <Row className="mt-2">
                            <FormGroup as={Col} xs={2} className="d-flex flex-column"> 
                                <Button variant="primary" onClick={addCustomerToggleEditorDialog}>
                                    <PersonAdd className={'me-2'} size={17}></PersonAdd>
                                      Legg til ny eier
                                </Button>
                            </FormGroup> 
                            <FormGroup as={Col} xs={3} className="d-flex flex-column"> 
                                <Select
                                    style={{width:"10px"}}
                                    placeholder={"Velg eksisterende kunde"}
                                    aria-labelledby="aria-label"
                                    inputId="aria-example-input"
                                    name="aria-live-color"
                                    onChange={onChange}
                                    options={customerDetailList}
                                />
                            </FormGroup> 
                        </Row>
                        
                      </Col>
                </Row>
              </Form>
              <AddCustomerModal
                show={addCustomershowEditorDialog}
                initialValues={addCustomerdialogValues}
                handleFormSubmit={addCustomerHandleFormSubmit}
                toggleEditorDialog={addCustomerToggleEditorDialog}
              />
              {loader}
            </Fragment>
      {/* <Formik
        initialValues={state}
        onSubmit={handleSubmit}
        // validationSchema={ownershipValidationSchema}
        enableReinitialize={true}>
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => {
          return (
            <Fragment>
              <Form onSubmit={handleSubmit} className="px-3">
                <div className="viewer_actions d-flex align-items-center justify-content-end gap-2 mb-4">
                  <Button
                    type="button"
                    variant="primary"
                    onClick={() => toggleContractPersonEditorDialog(false)}>
                   <ArrowLeftCircle className={'me-2'} size={17}></ArrowLeftCircle>
                    Tilbake
                  </Button>
                  <Button type="submit" variant="primary">
                    Lagre
                  </Button>
                </div>

                <Row className="justify-content-between">
                  <Col md={6} sm={7}>
                    <h4 className="fw-bold">
                        {screenType === "Edit" ? "Redigere" : "Legge til"} kontaktperson
                    </h4>
                  </Col>
                </Row>
                

                <div className="mt-3 mb-4 border-top" />

                <Row>
                  <FieldArray >
                    {() => (
                      <Col xs={12}>
                        <Table responsive hover className="mb-3">
                          <thead className="bg-gray-300">
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Navn</th>
                              <th scope="col">E-post</th>
                              <th scope="col">Telefon</th>
                              <th scope="col"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {values.personList.map((item, ind) => (
                              <tr key={ind}>
                                <th className="text-middle" scope="row">
                                  {ind + 1}
                                </th>
                                <td>
                                  <FormControl
                                    value={values.personList[ind].Name}
                                    name={`personList[${ind}].Name`}
                                    type="text"
                                    placeholder="Navn"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    
                                  />
                                </td>
                                <td>
                                  <FormControl
                                    value={values.personList[ind].Email}
                                    name={`personList[${ind}].Email`}
                                    type="text"
                                    placeholder="e-post"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                </td>
                                <td>
                                  <FormControl
                                    value={values.personList[ind].Phone}
                                    name={`personList[${ind}].Phone`}
                                    type="text"
                                    placeholder="telefon"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                </td>
                                <td>
                                  <button
                                    type="button"
                                    onClick={() => handleDeleteCustomer(ind, item.CustomerID)}
                                    className="btn btn-outline-secondary float-right">
                                    Slett
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>

                        {isFormSubmit && values.personList.length === 0 &&
                          <small className="text-danger">Minimum 1 vare kreves</small>
                        }

                        

                        <Row className="mt-2">
                            <FormGroup as={Col} xs={2} className="d-flex flex-column"> 
                                <Button variant="primary" onClick={addCustomerToggleEditorDialog}>
                                    <PersonAdd className={'me-2'} size={17}></PersonAdd>
                                      Legg til ny eier
                                </Button>
                            </FormGroup> 
                            <FormGroup as={Col} xs={3} className="d-flex flex-column"> 
                                <Select
                                    style={{width:"10px"}}
                                    placeholder={"Velg eksisterende kunde"}
                                    aria-labelledby="aria-label"
                                    inputId="aria-example-input"
                                    name="aria-live-color"
                                    onChange={onChange}
                                    options={customerDetailList}
                                />
                            </FormGroup> 
                        </Row>
                        
                      </Col>
                    )}
                  </FieldArray>
                </Row>
              </Form>
              <AddCustomerModal
                show={addCustomershowEditorDialog}
                initialValues={addCustomerdialogValues}
                handleFormSubmit={addCustomerHandleFormSubmit}
                toggleEditorDialog={addCustomerToggleEditorDialog}
              />
              {loader}
            </Fragment>
          );
        }}
      </Formik> */}
    </div>
  );
}

